// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__3VjUi","variant-secondary":"styles_variant-secondary__1wT_1","variantSecondary":"styles_variant-secondary__1wT_1","tabsWrapper":"styles_tabsWrapper__i85v6"};